export default (size, iconUrl) => {
  let anchorY = size.height;

  if (size.width === size.height) {
    anchorY = anchorY / 2;
  }

  return {
    url: iconUrl,
    anchor: { x: parseInt(size.width / 2), y: parseInt(anchorY) },
    size: { width: size.width, height: size.height, f: 'px', b: 'px' },
    scaledSize: { width: size.width, height: size.height, f: 'px', b: 'px' },
  };
};
